import type { FC, ReactNode } from 'react'

import { useRef } from 'react'

import { useEntrance, useSiteAnimations } from '@/lib/anim'
import { Navbar } from '@/components/generals/navbar'
import { Footer } from '@/components/generals/footer'
import { AppointmentSection } from '@/components/generals/appointment-section'
import { VisitSection } from '@/components/generals/visit-section'
import { ProgressiveBlur } from '@/components/generals/progressive-blur'

type SiteShellProps = {
    children: ReactNode
    appointment?: boolean
    visit?: boolean
}

/**
 * Every page renders through here, so the nav, menu, pre-footer blocks, footer
 * and the whole animation system behave identically across the site.
 */
export const SiteShell: FC<SiteShellProps> = ({ children, appointment = true, visit = true }) => {
    const scope = useRef<HTMLDivElement>(null)

    useEntrance(scope)
    useSiteAnimations(scope)

    return (
        <div ref={scope} className='relative flex min-h-screen w-full flex-col overflow-x-clip bg-background'>
            <Navbar />

            <ProgressiveBlur position='top' height={72} />
            <ProgressiveBlur position='bottom' height={64} />

            <main className='flex-1'>{children}</main>

            {appointment && <AppointmentSection />}
            {visit && <VisitSection />}

            <Footer />
        </div>
    )
}
